import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CaretExpandIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M8,9.7l3.46-3.48a.78.78,0,0,1,1.08,0L16,9.7a.76.76,0,0,1-.54,1.3H8.54A.76.76,0,0,1,8,9.7Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8,14.3l3.46,3.48a.78.78,0,0,0,1.08,0L16,14.3a.76.76,0,0,0-.54-1.3H8.54A.76.76,0,0,0,8,14.3Z"
  })]
}), 'CaretExpandIcon');